export { default as DiscountBadgeSmall } from './DiscountBadgeSmall';
